import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { SessionService } from '../services/session.service';

@Injectable({ providedIn: 'root' })
export class RoleGuard implements CanActivate {

    constructor(private router: Router, private sessionService: SessionService) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        let requiredRoles: string[] = [];
        let currentRoute: ActivatedRouteSnapshot | null = route;

        while (currentRoute) {
            if (currentRoute.data && currentRoute.data['roles']) {
            requiredRoles = [...requiredRoles, ...currentRoute.data['roles']];
            }
            currentRoute = currentRoute.parent!;
        }

        if (requiredRoles.length === 0) {
            return true;
        }

        const userRole = this.getUserRole();
        const hasRole = requiredRoles.includes(userRole);

        if (!hasRole) {
            this.router.navigate(['access-denied']);
        }

        return hasRole;
    }

    
    private getUserRole(): string{
        let role = this.sessionService.getUserRole();        
        if(role === null) 
            return '';
        return role;
    }
}